// This is just an example,
// so you can safely delete all default props below

export default {
    my_account: 'My account',
    ticket: 'Tickets',
    signin: 'Login',
    sign_out: 'Logout',
    link_terms: 'Ticket Terms',
    link_term_purchase: 'Terms - ticket purchase',
    link_term_reservation: 'Terms - reservation',
    link_term_free_ferry: 'Terms - free ferry',
    link_term_auto_pass: 'Terms - AutoPASS',
    link_term_cancellation: 'Ticket Cancellation',
    link_term_change:'Ticket Change'
}
